import React from 'react';
import { Item, registry, RenderProps } from '../Item';
import { BUTTON } from '../itemIds';
import { Button, Link } from '~/ui/buttons';
import { decodeHtmlEntities } from '~/lib/decodeHtmlEntities';

interface Props {
  title: string;
  url: string;
  type?: string;
  display?: 'block' | 'inline' | 'flex' | 'inline-flex';
  showShadow?: boolean;
}

export class LinkButton extends Item<typeof BUTTON, Props> {
  protected render({
    title,
    url,
    type = 'button',
    display = 'block',
    showShadow
  }: RenderProps<Props>) {
    const decodedTitle = decodeHtmlEntities(title);

    if (type === 'button') {
      return (
        <Button h={'46px'} onClick={() => window.open(url, '_blank')}>
          {decodedTitle}
        </Button>
      );
    } else {
      return (
        <Link
          display={display}
          showShadow={showShadow}
          href={url}
          target="_blank"
        >
          {decodedTitle}
        </Link>
      );
    }
  }
}

registry[BUTTON] = LinkButton;
